export const enum MutationNames {
  updateSiteReadings = 'SITE_READINGS_UPDATE_SITE_READINGS',
}

export const enum ActionNames {
  getSiteReadingsById = 'SITE_READINGS_GET_SITE_READINGS_BY_ID',
}

export const enum GetterNames {
  siteReadings = 'SITE_READINGS_SITE_READINGS',
}
